export function getIntegrationsDisconnectDescription({
  liveAdCount,
  portal,
  t,
}) {
  return liveAdCount > 0
    ? t('RentalPortal.IntegrationsDisconnectLiveAdsKey', {
        count: liveAdCount,
        portal,
      })
    : t('RentalPortal.IntegrationsDisconnectNoAdsKey', { portal })
}
